var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('room-rent-list',{attrs:{"channelType":_vm.channelType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }